import template from './button-tab.html';
import controller from './button-tab.controller';
import './button-tab.scss';

let buttonTabComponent = {
    restrict: 'E',
    transclude: true,
    bindings: {
        tabs: '=',
        onLoaded: '&'
    },
    template,
    controller
};

export default buttonTabComponent;



// WEBPACK FOOTER //
// ./src/app/common/button-tab/button-tab.component.js